import type {
  ISite,
  ISiteSystem,
  ISiteSystemEquipment,
  ISiteSystemType,
} from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

import API from '@/Core.Service.Domain/Sites/SiteSystems/API/index.ts';

type CommitFn = (mutation: string, payload?: unknown) => void;

interface IActionContext {
  commit: CommitFn;
}

const setSiteSystems = async (
  { commit }: IActionContext,
  siteId: number
): Promise<void> => {
  commit('SET_SITE_SYSTEMS_LOADING', true);
  try {
    const data: ISiteSystem[] = await API.getSiteSystems(siteId);
    commit('SET_SITE_SYSTEMS', data);
  } finally {
    commit('SET_SITE_SYSTEMS_LOADING', false);
  }
};

const setSiteSystem = async (
  { commit }: IActionContext,
  id: number
): Promise<void> => {
  const data: ISiteSystem = await API.getSiteSystem(id);
  commit('SET_SITE_SYSTEM', data);
};

const clearSiteSystem = ({ commit }: IActionContext): void => {
  commit('SET_SITE_SYSTEM', null);
};

const setSiteSystemTypes = async ({
  commit,
}: IActionContext): Promise<void> => {
  const data: ISiteSystemType[] = await API.getSiteSystemTypes();
  commit('SET_SITE_SYSTEM_TYPES', data);
};

const setSitesForSelector = async ({
  commit,
}: IActionContext): Promise<void> => {
  const data: ISite[] = await API.getSitesPortfolio();
  commit('SET_SITES_FOR_SELECTOR', data);
};

const setEquipmentForSite = async (
  { commit }: IActionContext,
  siteId: number
): Promise<void> => {
  const data: ISiteSystemEquipment[] = await API.getEquipmentForSite(siteId);
  commit('SET_EQUIPMENT_FOR_SITE', data);
};

export default {
  setSiteSystems,
  setSiteSystem,
  clearSiteSystem,
  setSiteSystemTypes,
  setSitesForSelector,
  setEquipmentForSite,
};
